const WINDOW_NAME = '[object Window]';
export { WINDOW_NAME };
